var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.648 8.685L.452 6.081c-.486-.396-.206-1.184.421-1.184H5L6.38.826c.204-.6 1.05-.605 1.26-.007l1.438 4.078h4.051c.627 0 .908.787.422 1.184l-3.19 2.604 1.004 3.942a.667.667 0 01-1.02.716l-3.34-2.273-3.347 2.273a.666.666 0 01-1.02-.717l1.01-3.94z",
    fill: "currentColor"
  })));
}

var MemoSvgStar = /*#__PURE__*/React.memo(SvgStar);
export default MemoSvgStar;